import {useState} from 'react';
import './coupons.css';
import Empty from "@/assets/imgs/empty.png"
import { CouponDetailModal } from './CouponDetailModal';

export const Coupons = () => {
  const [selectedCoupon, setSelectedCoupon] = useState(null);

  const coupons = [
    {
      id: 1,
      title: 'Cupón de descuento',
      description1: 'Primera compra',
      description2: '¡Disponible para uso en todas las tiendas!'
    },
    {
      id: 2,
      title: 'Cupón de descuento',
      description1: 'Barquillería',
      description2: '¡Disponible para uso en todas las tiendas Barquillería!'
    },
    {
      id: 3,
      title: 'Cupón de descuento',
      description1: 'Barquillería',
      description2: '¡Disponible para uso en todas las tiendas Barquillería!'
    }
  ];

  if(coupons.length >0)
    return (
      <div className="coupon-container">
        {selectedCoupon && (
        <CouponDetailModal
          coupon={selectedCoupon}
          onClose={() => setSelectedCoupon(null)}
        />
      )}
        <h2 className="coupon-title">Cupones</h2>
        <div className="coupon-cards">
          {coupons.map(coupon => (
            <div key={coupon.id} className="coupon-card" onClick={() => setSelectedCoupon(coupon)}>
              <h3 className="coupon-card-title">{coupon.title}</h3>
              <p className="coupon-description">{coupon.description1}</p>
              <p className="coupon-description">{coupon.description2}</p>
              <div className="coupon-buttons">
                <button className="coupon-button-outline">Ver detalle</button>
                <button className="coupon-button-filled">Activar cupón</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
    else 
    return(
      <div className="coupon-container">
      <h2 className="coupon-title">Cupones</h2>
        <div className="coupons-empty">
          <img src={Empty} alt={"no hay ordenes"} className="" />
          <h2 className="coupons-empty-title">¡Usaste todos tus cupones!</h2>
          <p className="coupons-empty-subtitle">
            Cuando actives o recibas un cupón,<br />
            aparecerá aquí automáticamente.
          </p>
        </div>
      </div>
  )
};
